import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Build18 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={18}
    contrast={contrast}
    className={className}
  >
    <g clipPath='url(#clip0_1_521)'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M1.75008 5.25006V13.7501H3.52008V15.2501H1.64489C0.881947 15.2583 0.241832 14.6182 0.250081 13.8552V2.14492C0.241831 1.38196 0.881964 0.741831 1.64492 0.750081H16.3552C17.1182 0.741831 17.7584 1.382 17.7501 2.14498V13.8552C17.7584 14.6182 17.1182 15.2583 16.3553 15.2501H14.4801V13.7501H16.2501V5.25006H1.75008ZM1.75008 3.75006V2.25008H3.25V3.75006H1.75008ZM4.75 3.75006V2.25008H16.2501V3.75006H4.75Z'
        fill='currentColor'
      />
      <path
        d='M11.2616 7.3432L10.365 6.84924L9.58485 10.7501H8.41456L7.63703 6.86246L6.74614 7.33867C5.99772 7.73873 5.37014 8.33199 4.92866 9.05676C4.48719 9.78154 4.24796 10.6113 4.23584 11.4599C4.22371 12.3085 4.43915 13.1448 4.85974 13.8819C5.20614 14.4889 5.68128 15.0104 6.2497 15.4109V17.5001H7.7497V14.565L7.37201 14.349C6.86796 14.0608 6.45033 13.6428 6.16256 13.1385C5.87479 12.6341 5.72739 12.0619 5.73568 11.4813C5.74398 10.9007 5.90767 10.333 6.20972 9.83708C6.32253 9.65188 6.4531 9.47923 6.5991 9.32133L7.18485 12.2501H10.8146L11.3962 9.34173C11.5305 9.49245 11.651 9.65595 11.7557 9.83038C12.051 10.3221 12.2109 10.8833 12.2192 11.4568C12.2275 12.0304 12.0838 12.5959 11.8027 13.096C11.5217 13.596 11.1133 14.0128 10.619 14.3039L10.2497 14.5214V17.5001H11.7497V15.355C12.307 14.9527 12.7719 14.4331 13.1103 13.8309C13.5211 13.1001 13.7311 12.2735 13.719 11.4353C13.707 10.597 13.4733 9.77684 13.0417 9.05813C12.61 8.33942 11.9959 7.74774 11.2616 7.3432Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_1_521'>
        <rect width='18' height='18' fill='white' />
      </clipPath>
    </defs>
  </Svg>
);

Build18.displayName = 'Build18';
export default Build18;
